export * from './components/navbar.component';
export * from './components/sidebar.component';
export * from './components/menu-item.component';
export * from './components/footer.component';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin-template/index.ts